@file:kotlin.js.JsExport
/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 30/Jul/2024.
 */



package com.narbase.car.dto.domain.appSettings

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.EnumDtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.routing.domain.appSettings.CapacitorAppInfoDto
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
object GetMobileLatestVersionEndpoint :
    EndPoint<GetMobileLatestVersionEndpoint.Request, GetMobileLatestVersionEndpoint.Response>() {

    class Request(
        val appInfo: CapacitorAppInfoDto
    )

    class Response(
        val isUpdateAvailable: Boolean,
        val isOptional: Boolean,
        val inBackground: Boolean,
        val optionsOfExternalUpdate: ExternalUpdate,
        val optionsOfOverTheAirUpdate: OverTheAirUpdate?,
        @Suppress("NON_EXPORTABLE_TYPE") val typeOfOptions: DtoName<UpdateType>,
        val statsUrl: String? = null,
    )


    class ExternalUpdate(
        val externalUrl: String,
        @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<UpdateType> /*= UpdateType.ExternalUpdate.dto()*/
    )

    class OverTheAirUpdate(
        val downloadOptions: CapacitorUpdaterPluginDownloadOptions,
        @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<UpdateType> /*= UpdateType.OverTheAirUpdate.dto()*/
    )


    enum class UpdateType(override val dtoName: String) : EnumDtoName {
        ExternalUpdate("external_update"),
        OverTheAirUpdate("over_the_air_update"),
        ;
    }

}

data class CapacitorUpdaterPluginDownloadOptions(
    val url: String,
    val version: String,
    val sessionKey: String? = null,
    val checksum: String? = null,
)
